<template>
  <div>
    <header class="inner-banner">
      <div class="container">
        <div class="row">
          <div class="inner-wrapper">
            <div class="col-md-12">
              <!-- Login -->
              <div class="container">
                <div class="card card-container">
                  <a href="/">
                    <img src="images/logo.png" alt="Logo" class="text-center" />
                  </a>
                  <div class="coach-verifcation-form">
                    <h2 style="padding: 10px 0 20px;">Login Form</h2>
                    <a-form
                      id="components-form-demo-normal-login"
                      :form="form"
                      class="login-form"
                      @submit="handleSubmit"
                    >
                      <a-form-item
                        :validate-status="handleError('email') ? 'error' : ''"
                        :help="handleError('email') || ''"
                      >
                        <a-input
                          v-decorator="[
                            'email',
                            {
                              rules: [
                                {
                                  type: 'email',
                                  message: 'The input is not valid E-mail!'
                                },
                                {
                                  required: true,
                                  message: 'Please input your E-mail!'
                                }
                              ]
                            }
                          ]"
                          type="email"
                          placeholder="Email"
                        >
                          <a-icon
                            slot="prefix"
                            type="user"
                            style="color: rgba(0,0,0,.25)"
                          />
                        </a-input>
                      </a-form-item>
                      <a-form-item
                        :validate-status="
                          handleError('password') ? 'error' : ''
                        "
                        :help="handleError('password') || ''"
                      >
                        <a-input
                          v-decorator="[
                            'password',
                            {
                              rules: [
                                {
                                  required: true,
                                  message: 'Please input your Password!'
                                }
                              ]
                            }
                          ]"
                          type="password"
                          placeholder="Password"
                        >
                          <a-icon
                            slot="prefix"
                            type="lock"
                            style="color: rgba(0,0,0,.25)"
                          />
                        </a-input>
                      </a-form-item>
                      <a-form-item>
                        <a-button
                          type="primary"
                          html-type="submit"
                          class="login-form-button next-button save-button"
                          :disabled="hasErrors(form.getFieldsError())"
                          >Log in</a-button
                        >
                      </a-form-item>
                    </a-form>
                    <div class="d-flex-column">
                      <span
                        class="pointer-hover margin-bottom-1"
                        @click="handleForgotPassword"
                      >
                        Forgot Password?
                      </span>
                      <router-link
                        to="/register"
                        class="color-secondary pointer-hover margin-bottom-1"
                      >
                        Register
                      </router-link>
                      <a href="/" class="pointer-hover color-black">
                        Back To Top Notch Athletes
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { Base } from "@/models";
import ChatSockets from "@/helpers/chat-sockets";
import { BASE_URL } from "@/utils/api-url";
import { Notification } from "ant-design-vue";

import { RepositoryFactory } from "../../repositories/RepositoryFactory";
const UserRepository = RepositoryFactory.get("users");

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

const STORE_KEY = "userStore";

export default {
  data() {
    return {
      email: "",
      password: null,
      form: this.$form.createForm(this),
      hasErrors
    };
  },
  methods: {
    ...mapActions(["setUser"]),

    handleError(val) {
      const { getFieldError, isFieldTouched } = this.form;
      return isFieldTouched(val) && getFieldError(val);
    },
    handleForgotPassword() {
      this.$router.push("/reset-password");
    },
    async handleSubmit(e) {
      e.preventDefault();
      let that = this;
      this.form.validateFields((err, values) => {
        if (!err) {
          UserRepository.loginUsers(values)
            .then(async response => {
              if (response.status == "success") {
                // document.cookie = `token = ${response.token}`;
                localStorage.clear();
                this.setUser(response.data.user);
                localStorage.token = JSON.stringify(response.data.token);
                var datas = {
                  routeName: this.onlyPlayer()
                    ? "ProfileList"
                    : this.onlyCollegeCoach()
                    ? "CoachProfile"
                    : this.onlyClubCoach()
                    ? "ClubCoachProfile"
                    : "",
                  id: this.onlyPlayer() ? response.data.user._id : null
                };
                if (this.exceptPlayer())
                  await this.$store.dispatch(`${STORE_KEY}/getProfile`);
                this.goProfile(datas);
                // setTimeout(function() {
                //   that.goProfile(datas);
                // }, 500);
              }
            })
            .catch(error => {
              if (!error.response) {
                this.$notification.error({
                  message: "Server is Offline",
                  description: "Please Try Again Later"
                });
              }
              this.$notification.error({
                message: "Error",
                description: error.response.data.message
              });
            });
        }
      });
    },
    goProfile(datas) {
      let query = {
        athlete: "profile-list",
        clubCoach: "club-profile",
        collegeCoach: "college-profile"
      };
      this.$router.push({
        name: datas.routeName,
        params: {
          id: datas.id,
          profileId: localStorage["profile-id"]
        },
        query: { key: query[Base.userType()] }
      });
    }
  },

  mounted() {
    const logged_by = localStorage.getItem('logged_by') || '';
    if(logged_by === 'Self'){
        Notification.success({
        description: localStorage.getItem('logged_msg'),
        duration:5
      });  
      localStorage.clear();
    }else if(logged_by === 'Admin'){
        Notification.error({
        description: localStorage.getItem('logged_msg'),
        duration:5
      });  
      localStorage.clear();
    }else{
      localStorage.clear();
    }
    if (this.$route.query.password_changed) {
      this.$notification.error({
        message: "Error",
        description: sessionStorage["message"]
      });
      sessionStorage.clear();
      this.$router.replace(`/login`);
    }
    this.anime = this.$anime({
      targets: ".card",
      scale: [0, 1],
      opacity: [0, 1],
      easing: "easeInOutSine",
      duration: 300
    });
  }
};
</script>

<style lang="scss" scoped>
.save-button {
  margin-top: 15px;
  width: 100%;
  border-radius: 4px !important;
}
</style>
